import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';



class SeoMeta extends React.PureComponent {

   getCanonical = (canonical) => {
     const { storeDomain, pathname } = this.props;
     //if no canonical provided, references self
     return canonical || `https://${storeDomain}${pathname}`
   }

    render() {
		const {
			seo: {
				title,
				canonical,
				description,
				keywords,
				robots
			},
      storeEnvironment,
      previewMode
		} = this.props;
        const isNotProduction = storeEnvironment !== 'production';
        return(
                 <Helmet>
                        <meta charSet="utf-8"/>
                        <title>{title}</title>
                        <link rel="canonical" href={this.getCanonical(canonical)}/>
                        <meta name="description" content={description}/>
                        <meta name="keywords" content={keywords}/>
                        { (isNotProduction || robots || previewMode) &&
                            <meta name="robots" content="noindex"/>
                        }
                    </Helmet>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
  const { storeEnvironment, storeDomain, router } = state;
  const { location } = router;
  const { pathname } = location;
  return {
    storeEnvironment,
    storeDomain,
    pathname
  }
}

export default connect(mapStateToProps, undefined)(SeoMeta);